define(function (require, exports, module) {
  'use strict';

  // @ngInject
  module.exports = function ($compile, $timeout) {
    const OTP_REPLACE_REGEX = /[^0-9]+/g;
    const MASKEDKEY = "masked";
    return {
      restrict: 'E',
      replace: true,
      scope: {
        pin: '=ngModel',
        callback: '&callback'
      },
      template: '',
      link: function (scope, element, attrs, ctrl) {
        scope._masked = (attrs.masked && attrs.masked !== "" && attrs.masked === MASKEDKEY);
        var content = '<div class="lp-otp-wrap">';
        for (var i = 0; i < attrs.numbers; i++) {
          content = content +  getTemplate();
        }
        content = content + '<input type="tel" id="otp-text" ng-class="otp-text" ng-model="pin" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" set-focus/>';
        content = content + '</div>';
        element.append(content);
        $compile(element.contents())(scope);

        function getTemplate(){
          return scope._masked ?'<span ng-class="{\'masked\': pin.length > ' +  i + '}"></span>' : '<span ng-class="{\'unmasked\': pin.length > ' +  i + '}" ng-bind="pin['+ i + ']"></span>';
        }

        element.on( 'input', function(event) {
          scope.pin = scope.getFilteredValue(event.target.value);

          if (!scope._masked && scope.pin) {
            scope.pin.split("");
          }

          scope.$apply();

          if (scope.pin !== null && scope.pin !== undefined && scope.pin.length === 6) {
            $("#otp-text").blur();
            $timeout(function(){scope.callback();},500);
          }
        });

        scope.getFilteredValue = function (value) {
          if (!value) return null;
          return value.replace(OTP_REPLACE_REGEX, '').substring(0, attrs.numbers);
        }
      }
    };
  };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/portal/otp-mobile.js
// module id = 16
// module chunks = 0